module.exports = __webpack_public_path__ + "img/ring_y_0_null_1@2x.40fa839c.png";